const service = {
  tab: {
    main: "Service",
    dependency: "Option",
    technicalData: "Données techniques",
    publicTechnicalData: "Données techniques publiques",
    phoneSystemReportingConfiguration: "Conf. rapport tél.",
    activeContract: "Contract actif",
    archiveContract: "Archive contrat",
    phonePackageApi: "API Téléphonie",
    phonePackageOrder: "Forfait téléphonique",
    phonePackageConsumption: "Consommations",
    dataRecharge: "Recharge mobile",
    specificPhonePriceList: "Grille tarifaire téléphonique spéciale",
    amendment: "Avenants",
    centreonConfiguration: "Conf Centreon",
    centreonChart: "Supervision"
  },
  search: {
    serialNumber: "Numéro de série",
    orderNumber: "Numéro de CMD",
    quoteNumber: "Numéro de devis",
    productName: "Nom du produit",
    price: "Prix",
    state: "Etat",
    partner: "Client",
    client: "Compte client",
    place: "Site",
    productFamily: "Famille de produit",
    productSubFamily: "Sous-famille de produit",
    deliveryDateTimeframe: "Plage de temps / Livraison",
    deliveryDateMin: "Livré après",
    deliveryDateMax: "Livré avant",
    updateDateTimeframe: "Plage de temps / MàJ",
    updateDateMin: "Mise à jour après",
    updateDateMax: "Mise à jour avant",
    emptyApiKey: "Clé d'API vide",
    phoneSystemReporting: "Rapport système téléphonique"
  },
  tabs: {
    buttons: {
      disable: "Désactiver",
      termination: "Résilier",
      cancelTermination: "Annuler la résiliation",
      terminate: "Valider la résiliation",
      terminateNoBill: "Valider la résiliation (sans frais)",
      waitTermination: "Annuler le renouvellement automatique",
      unwaitTermination: "Réactiver le renouvellement automatique",
      scheduleTermination: "Planifier la résiliation",
      unscheduleTermination: "Supprimer la planification de résiliation",
      removeTerminationBill: "Enlever les frais de résiliation",
      reactivateTerminationBIll: "Réactiver les frais de résiliation",
      removeLastBill: {
        label: "Annuler les frais de résiliation",
        flashbagMessage: "Les frais de résiliation ont été annulés.",
        flashbagMessageFailure: "Les frais de résiliation n'ont pas pu être annulés."
      },
      reactivateLastBill: {
        label: "Réactiver les frais de résiliation",
        flashbagMessage: "Les frais de résiliation ont été réactivés.",
        flashbagMessageFailure: "Les frais de résiliation n'ont pas pu être réactivés."
      },

      amendment: "Nouvel avenant",
      relocation: {
        label: "Déménager",
        title: "Déménagement",
        successButton: "Déménager",
        flashbagMessage: "Déménagement réussi.",
        flashbagMessageFailure: "Déménagement échoué.",
        form: {}
      },
      addPhonePackage: "Ajout Téléphonie",
      activatePhonePackageOrder: {
        label: "Réactiver Téléphonie",
        flashbagMessage: "La téléphonie a été réactivée.",
        flashbagMessageFailure: "La téléphonie n'a pas pu être réactivée."
      },
      deactivatePhonePackageOrder: {
        label: "Désactiver Téléphonie",
        flashbagMessage: "La téléphonie a été désactivée.",
        flashbagMessageFailure: "La téléphonie n'a pas pu être désactivée."
      },
      wipeCalculation: {
        label: "Recalcule CDR",
        title: "Demande de recalcul des CDR",
        successButton: "Recalculer",
        flashbagMessage: "Demande de recalcul réussi.",
        flashbagMessageFailure: "Demande de recalcul échoué.",
        form: {
          beginAtMin: {
            label: "Date de début"
          },
          beginAtMax: {
            label: "Date de fin"
          }
        }
      },
      transfer: {
        label: "Transfert CDR",
        title: "Demande de transfert des CDR",
        successButton: "Transfèrer",
        flashbagMessage: "Demande de transfert réussi.",
        flashbagMessageFailure: "Demande de transfert échoué.",
        form: {
          beginAtMin: {
            label: "Date de début"
          },
          beginAtMax: {
            label: "Date de fin"
          },
          phonePackageOrder: {
            label: "Cible"
          }
        }
      },

      suspendMobileService: "Suspendre la ligne mobile",
      addDataMobileService: {
        label: "Ajouter des données mobile",
        title: "Ajout de données mobile",
        successButton: "Ajouter",
        error: "L'ajout a échoué",
      },
      simSwapMobileService: {
        label: "Changement de carte SIM",
        title: "Activer un SimSwap",
        successButton: "SimSwap",
        error: "Le SimSwap a échoué",
      },
      reactivateMobileService: "Réactiver la ligne mobile",
      pukMobileService: "Code Puk",
      rioMobileService: "Code RIO",
      terminateMobileService: "Résilier la ligne mobile"
    }
  },
};

export default service;
